// @ts-ignore - Optional dependency
import { CredentialData } from '@keyringnetwork/keyring-connect-sdk'
import { TransactionItemBase, TransactionItemUnion, TransactionLabel } from './baseTransactionTypes'

export type KeyringTransaction = {
  label: TransactionLabel.KEYRING_VERIFY
  calldata: CredentialData
}

export type KeyringTransactionItem = TransactionItemBase<KeyringTransaction>

export function isKeyringTransactionItem(transaction?: TransactionItemUnion): transaction is KeyringTransactionItem {
  return transaction?.label === TransactionLabel.KEYRING_VERIFY
}
